import { FileTextOutlined, PaperClipOutlined } from "@ant-design/icons";
import RenderCoberturasHojaQX from "../components/RenderCoberturasHojaQX";
import RenderAnexos from "../components/RenderAnexos";
import { WINDOW_IDS, WINDOW_TITLES } from "./CrearValidacionHojaQXConstants";

export const getWindows = ({
  coberturasMedicos,
  documentosAnexos,
  abrirModalDocumento,
  archivosEnviados,
  coberturasEnviadas,
  coberturasDuplicadasIds,
  coberturasCompletas,
  handleEliminarCobertura,
  handleEliminarAnexo,
  coberturasEnviadasFlag = false,
  tipoReclamante,
}) => {
  return [
    {
      id: WINDOW_IDS.COBERTURAS_HOJA_QX,
      title: WINDOW_TITLES.COBERTURAS_HOJA_QX,
      icon: <FileTextOutlined />,
      content: () => (
        <RenderCoberturasHojaQX
          coberturasMedicos={coberturasMedicos}
          onEliminarCobertura={handleEliminarCobertura}
          coberturasEnviadas={coberturasEnviadas}
          coberturasDuplicadasIds={coberturasDuplicadasIds}
          coberturasEnviadasFlag={coberturasEnviadasFlag}
          tipoReclamante={tipoReclamante}
        />
      ),
    },
    {
      id: WINDOW_IDS.ANEXOS,
      title: WINDOW_TITLES.ANEXOS,
      icon: <PaperClipOutlined />,
      content: () => {
        const codigosCoberturasDuplicadas = new Set(
          coberturasCompletas
            .filter((c) => coberturasDuplicadasIds.has(c.id))
            .map((c) => c?.cobertura?.cobertura)
            .filter(Boolean)
        );

        return (
          <RenderAnexos
            documentosAnexos={documentosAnexos}
            abrirModalDocumento={abrirModalDocumento}
            archivosEnviados={archivosEnviados}
            onEliminarAnexo={handleEliminarAnexo}
            codigosCoberturasDuplicadas={codigosCoberturasDuplicadas}
            coberturasEnviadasFlag={coberturasEnviadasFlag}
          />
        );
      },
    },
  ];
};

